import Swiper from "swiper/bundle";

const BlogsSlider = () => {
  const sliders = Array.from(document.querySelectorAll(".blogs-slider"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const initSlider = new Swiper(slider, {
        spaceBetween: 12,
        slidesPerView: 1,
        lazy: {
          loadPrevNext: true,
        },
        breakpoints: {
          599: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1279: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    });
  }
};

export default BlogsSlider;
